import {
  POST_ORDINI_NTL_V1,
  PUT_ORDINI_SERVIZI_PLUS_V1,
} from '../../constants/ActionTypes'
import { fetchData } from '../Buy'

export const postOriniNltV1 = (dispatch, getState) => {
  const nltState = getState().nlt
  const body = {
    id_auto: getState().product.id_auto,
    id_canone: nltState.selectedCanone.id_canone,
    id_lead: getState().ordine.id_evento,
  }

  if (nltState.codiceCoupon) {
    // BRUM-11396 per supportare coupon benzina
    //  in contemporanea a codice_preventivo per
    //  canoni personalizzati
    body.codice_preventivo = nltState.codiceCoupon
  }

  return dispatch(
    fetchData(POST_ORDINI_NTL_V1)({
      method: 'POST',
      uri: `${window.brumbrum.url_api}/ordini/t/v1/ordini`,
      callback: POST_ORDINI_NTL_V1,
      errorMessage: POST_ORDINI_NTL_V1,
      body: JSON.stringify(body),
    })
  )
}

export const putOriniServiziPlusV1 = (dispatch, getState) =>
  dispatch(
    fetchData(PUT_ORDINI_SERVIZI_PLUS_V1)({
      method: 'PUT',
      uri: `${window.brumbrum.url_api}/ordini/t/v1/ordini/${
        getState().ordine.id_ordine
      }`,
      callback: PUT_ORDINI_SERVIZI_PLUS_V1,
      errorMessage: PUT_ORDINI_SERVIZI_PLUS_V1,
      body: JSON.stringify({
        servizi_extra: {
          nlt: getState().nlt.serviziPlusSelected,
        },
      }),
    })
  )

export const putOrdiniLogisticaV1 = (dispatch, getState) =>
  dispatch(
    fetchData(PUT_ORDINI_SERVIZI_PLUS_V1)({
      method: 'PUT',
      uri: `${window.brumbrum.url_api}/ordini/t/v1/ordini/${
        getState().ordine.id_ordine
      }`,
      callback: PUT_ORDINI_SERVIZI_PLUS_V1,
      errorMessage: PUT_ORDINI_SERVIZI_PLUS_V1,
      body: JSON.stringify({
        id_citta_consegna: getState().logistica.centro_convenzionato.id,
      }),
    })
  )
